import { DEFAULT_LANG, LANGS } from "./translations";

// This key only stores an explicit visitor choice. Automatic detection is
// repeated on a new visit so it can follow a change of country or browser.
export const LANGUAGE_STORAGE_KEY = "eternua_lang";

export function supportedLanguage(value) {
  const code = typeof value === "string" ? value.trim().toLowerCase() : "";
  return LANGS.some((language) => language.code === code) ? code : null;
}

export function browserLanguage(browser = typeof navigator === "undefined" ? null : navigator) {
  const preferences = browser?.languages?.length ? browser.languages : [browser?.language];
  for (const preference of preferences) {
    const code = supportedLanguage(String(preference || "").replace(/_/g, "-").split("-")[0]);
    if (code) return code;
  }
  return DEFAULT_LANG;
}

export function storedLanguage() {
  try {
    return supportedLanguage(window.localStorage.getItem(LANGUAGE_STORAGE_KEY));
  } catch (_) {
    return null;
  }
}

export function initialLanguage() {
  const choice = storedLanguage();
  // A new visitor starts in French. The server can then suggest English from
  // the country/browser, while a remembered explicit choice always wins.
  return { lang: choice || DEFAULT_LANG, manual: Boolean(choice) };
}

export function saveLanguage(code) {
  try {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, code);
  } catch (_) {
    // Switching language still works when browser storage is unavailable.
  }
}
